<div class="node-path-wrapper">
  <div class="node-path-container">
    <ul [ngClass]="{'cut-node-path': fieldImpact, 'cut-node-path-with-sync': !nodePath.length}">
      <li (click)="makeNodeRoot()">{{ refModel.name | decodeHtml }}</li>
      <li *ngFor="let node of nodePath" (click)="makeNodeRoot(node._id)">
        <span [matTooltip]="node.name" [matTooltipDisabled]="!fieldImpact || !nodePath.length">
          {{ node.name }}
        </span>
      </li>
    </ul>

    <div
      class="sync-status"
      *ngIf="!nodePath.length"
      [ngClass]="{
      inProgress: refModel.syncStatus === 'inProgress' || refModel.syncStatus === 'starting',
      failed: refModel.syncStatus === 'failed'
    }">
      <span>{{ getSyncMessage(syncStatus()) }}</span>
    </div>
  </div>
  <app-additional-sync-statuses [nodePathLength]="!!nodePath.length"></app-additional-sync-statuses>
</div>
